/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconFiletypeFolderWord = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M10 4h2.74L10 1.26V4zm2.094 3.002l-1.767 6.443h-.822L8.147 8.536c-.114-.41-.181-.662-.202-.755-.067.296-.13.547-.189.755l-1.367 4.909h-.87L3.81 7.002h.875l.98 4.224c.105.442.196.882.272 1.318.164-.688.261-1.086.29-1.191l1.226-4.351h1.028l.923 3.261c.232.809.399 1.568.501 2.281.082-.407.189-.875.321-1.402l1.011-4.14h.857zM14 15.557V5.001h-4c-.646 0-1-.438-1-1v-3H4a2 2 0 0 0-2 2v12.556c0 .245.198.443.443.443h11.114a.443.443 0 0 0 .443-.443z"
    />
  </svg>
);

IconFiletypeFolderWord.displayName = 'IconFiletypeFolderWord';

IconFiletypeFolderWord.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconFiletypeFolderWord);
IconFiletypeFolderWord.displayName = 'IconFiletypeFolderWord';
